var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShortBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 407.082,
    height: 220.089,
    viewBox: "0 0 407.082 220.089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(-2313.093 869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M374.462,101.2V75.189H358.825V101.2H340.308V60.964H326.728V30.888h-11.11V0H292.574V30.888h-11.11V60.964H268.3V24.792h-7.407V6.5h-4.526V24.792H230.026V140.217H209.863V128.024H197.518v12.193H177.355V101.2H141.143V75.189H125.506V101.2h-.823v49.99h-16.46V121.928H88.472v29.263H72.012V60.964H59.255V30.888H12.345V60.964H0V219.877H392.979V101.2Z",
    transform: "translate(2313.093 -869)",
    fill: "#0a1f39"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 17.171,
    height: 9.812,
    transform: "translate(2320.861 -797.261)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 17.171,
    height: 9.812,
    transform: "translate(2377.06 -787.449) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 17.171,
    height: 9.812,
    transform: "translate(2320.861 -777.772)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 17.171,
    height: 9.812,
    transform: "translate(2377.06 -767.959) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 17.171,
    height: 9.812,
    transform: "translate(2320.861 -758.282)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 17.171,
    height: 9.812,
    transform: "translate(2377.06 -748.47) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 17.171,
    height: 9.812,
    transform: "translate(2320.861 -738.792)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 17.171,
    height: 9.812,
    transform: "translate(2377.06 -728.98) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 17.171,
    height: 9.812,
    transform: "translate(2320.861 -719.302)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 17.171,
    height: 9.812,
    transform: "translate(2377.06 -709.49) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 17.171,
    height: 9.812,
    transform: "translate(2320.861 -699.813)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 17.171,
    height: 9.812,
    transform: "translate(2377.06 -690) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 17.171,
    height: 9.812,
    transform: "translate(2320.861 -680.456)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 17.171,
    height: 9.812,
    transform: "translate(2377.06 -670.644) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 40.067,
    height: 4.906,
    transform: "translate(2391.6 -704.829)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 40.067,
    height: 4.906,
    transform: "translate(2391.6 -697.367)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 40.067,
    height: 4.906,
    transform: "translate(2391.6 -690.123)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 40.067,
    height: 4.906,
    transform: "translate(2496.918 -702.342)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 40.067,
    height: 4.906,
    transform: "translate(2496.918 -694.879)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 40.067,
    height: 4.906,
    transform: "translate(2496.918 -687.62)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 40.067,
    height: 4.906,
    transform: "translate(2391.6 -682.615)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 40.067,
    height: 4.906,
    transform: "translate(2391.6 -675.107)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 40.067,
    height: 4.906,
    transform: "translate(2391.6 -667.6)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 11.039,
    height: 14.31,
    transform: "translate(2446.649 -756.182)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 11.039,
    height: 14.31,
    transform: "translate(2481.951 -741.873) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 11.039,
    height: 14.31,
    transform: "translate(2446.649 -732.955)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 11.039,
    height: 14.31,
    transform: "translate(2481.951 -718.646) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 11.039,
    height: 14.31,
    transform: "translate(2446.649 -709.728)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 11.039,
    height: 14.31,
    transform: "translate(2481.951 -695.418) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 11.039,
    height: 14.31,
    transform: "translate(2446.649 -686.648)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 11.039,
    height: 14.31,
    transform: "translate(2481.951 -672.338) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 14.718,
    height: 18.807,
    transform: "translate(2543.303 -834.879)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 14.718,
    height: 18.807,
    transform: "translate(2543.303 -806.769)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 14.718,
    height: 18.807,
    transform: "translate(2543.303 -779.388)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 14.718,
    height: 18.807,
    transform: "translate(2543.303 -752.006)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 14.718,
    height: 18.807,
    transform: "translate(2543.303 -724.625)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 14.718,
    height: 18.807,
    transform: "translate(2543.303 -697.434)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 54.785,
    height: 15.945,
    transform: "translate(2590.573 -795.164)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 54.785,
    height: 15.945,
    transform: "translate(2590.777 -760.321)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 54.785,
    height: 15.945,
    transform: "translate(2590.982 -725.477)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 54.785,
    height: 15.945,
    transform: "translate(2591.187 -690.797)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 7.359,
    height: 15.536,
    transform: "translate(2325.358 -828.765)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 18.398,
    height: 23.713,
    transform: "translate(2687.674 -756.125)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 18.398,
    height: 23.713,
    transform: "translate(2687.674 -721.266)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 18.398,
    height: 23.713,
    transform: "translate(2687.674 -686.498)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(2578.975 -733.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M156.236,584.247s-19.888,12,16.773,30.472c0,0,8.084-14.995-.854-27.221a12.039,12.039,0,0,0-15.619-3.423Z",
    transform: "translate(-150.851 -531.558)",
    fill: "#01a09b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M173.08,588.3s17.018,13.022,16.543,30.725",
    transform: "translate(-167.183 -535.863)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M234.972,512.77s-6.232-21.159,1.17-36.732a33.413,33.413,0,0,0,2.7-20.967,56.211,56.211,0,0,0-2.968-9.852",
    transform: "translate(-211.53 -428.927)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M236.208,392.094c0,2.594-4.7,10.1-4.7,10.1s-4.7-7.52-4.7-10.1a4.7,4.7,0,1,1,9.389,0Z",
    transform: "translate(-207.272 -387.289)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M266.838,442.011c-1.41,2.177-9.437,5.936-9.437,5.936s.147-8.864,1.556-11.042a4.7,4.7,0,0,1,7.881,5.1Z",
    transform: "translate(-230.084 -422.602)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M260.443,534.041c-2.316,1.167-11.143.361-11.143.361s4.6-7.578,6.916-8.745a4.7,4.7,0,1,1,4.229,8.385Z",
    transform: "translate(-224.037 -489.648)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M243.523,608.565c-2.084,1.541-10.923,2.238-10.923,2.238s3.254-8.245,5.338-9.789a4.7,4.7,0,1,1,5.585,7.551Z",
    transform: "translate(-211.582 -545.24)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M213.924,464.565c1.859,1.806,10.526,3.678,10.526,3.678s-2.122-8.606-3.981-10.415a4.7,4.7,0,1,0-6.543,6.735Z",
    transform: "translate(-196.533 -438.616)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M191.261,548.331c2.316,1.167,11.143.361,11.143.361s-4.6-7.578-6.916-8.745a4.7,4.7,0,1,0-4.229,8.385Z",
    transform: "translate(-178.819 -500.252)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M185.82,635.726c2.084,1.541,10.923,2.238,10.923,2.238s-3.254-8.248-5.34-9.789a4.7,4.7,0,1,0-5.585,7.551Z",
    transform: "translate(-175.268 -564.977)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M236.208,392.094c0,2.594-4.7,10.1-4.7,10.1s-4.7-7.52-4.7-10.1a4.7,4.7,0,1,1,9.389,0Z",
    transform: "translate(-207.272 -387.289)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M266.838,442.011c-1.41,2.177-9.437,5.936-9.437,5.936s.147-8.864,1.556-11.042a4.7,4.7,0,0,1,7.881,5.1Z",
    transform: "translate(-230.084 -422.602)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M260.443,534.041c-2.316,1.167-11.143.361-11.143.361s4.6-7.578,6.916-8.745a4.7,4.7,0,1,1,4.229,8.385Z",
    transform: "translate(-224.037 -489.648)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M243.523,608.565c-2.084,1.541-10.923,2.238-10.923,2.238s3.254-8.245,5.338-9.789a4.7,4.7,0,1,1,5.585,7.551Z",
    transform: "translate(-211.582 -545.24)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M213.924,464.565c1.859,1.806,10.526,3.678,10.526,3.678s-2.122-8.606-3.981-10.415a4.7,4.7,0,1,0-6.543,6.735Z",
    transform: "translate(-196.533 -438.616)",
    fill: "#5ec5c1",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M191.261,548.331c2.316,1.167,11.143.361,11.143.361s-4.6-7.578-6.916-8.745a4.7,4.7,0,1,0-4.229,8.385Z",
    transform: "translate(-178.819 -500.252)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M185.82,635.726c2.084,1.541,10.923,2.238,10.923,2.238s-3.254-8.248-5.34-9.789a4.7,4.7,0,1,0-5.585,7.551Z",
    transform: "translate(-175.268 -564.977)",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(2679.79 -761.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M1005.844,513.788s-8.321-28.252,1.562-49.047a44.613,44.613,0,0,0,3.609-28,75.058,75.058,0,0,0-3.963-13.155",
    transform: "translate(-986.177 -401.675)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M1009.448,372.076c0,3.464-6.271,13.492-6.271,13.492s-6.271-10.042-6.271-13.492a6.271,6.271,0,1,1,12.538,0Z",
    transform: "translate(-982.424 -365.66)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M1040.052,422.261c-1.882,2.908-12.6,7.927-12.6,7.927s.2-11.836,2.078-14.743a6.27,6.27,0,1,1,10.524,6.814Z",
    transform: "translate(-1002.666 -396.346)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M1034.239,515.391c-3.093,1.558-14.879.482-14.879.482s6.142-10.119,9.235-11.678a6.27,6.27,0,1,1,5.647,11.2Z",
    transform: "translate(-997.305 -456.109)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M1017.245,589.776c-2.783,2.058-14.585,2.988-14.585,2.988s4.344-11.01,7.127-13.07a6.27,6.27,0,1,1,7.458,10.082Z",
    transform: "translate(-986.238 -505.215)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M984.684,445.842c2.483,2.412,14.056,4.911,14.056,4.911s-2.833-11.492-5.316-13.907a6.271,6.271,0,1,0-8.739,9Z",
    transform: "translate(-973.065 -411.2)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M962.5,529.821c3.093,1.558,14.878.482,14.878.482s-6.142-10.119-9.235-11.677a6.27,6.27,0,0,0-5.643,11.2Z",
    transform: "translate(-957.431 -465.617)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M956.516,616.936c2.783,2.058,14.585,2.988,14.585,2.988s-4.345-11.01-7.128-13.07a6.27,6.27,0,1,0-7.458,10.082Z",
    transform: "translate(-953.974 -523.019)",
    fill: "#017572"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(2564.339 -722.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M899.692,597.919s5.421-18.4-1.018-31.947a29.066,29.066,0,0,1-2.351-18.234,48.9,48.9,0,0,1,2.58-8.557",
    transform: "translate(-886.352 -524.758)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M892.72,512.319c0,2.257,4.088,8.794,4.088,8.794s4.089-6.542,4.089-8.794a4.088,4.088,0,1,0-8.177,0Z",
    transform: "translate(-884.171 -508.23)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M909.911,539.443c1.226,1.893,8.21,5.164,8.21,5.164s-.127-7.711-1.353-9.6a4.088,4.088,0,1,0-6.856,4.44Z",
    transform: "translate(-908.112 -522.667)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M906.893,589.934c2.016,1.014,9.694.315,9.694.315s-4-6.591-6.014-7.6a4.088,4.088,0,0,0-3.679,7.294Z",
    transform: "translate(-904.8 -551.449)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M897.32,629.9c1.815,1.341,9.5,1.946,9.5,1.946s-2.829-7.171-4.644-8.512a4.089,4.089,0,0,0-4.857,6.566Z",
    transform: "translate(-891.363 -574.101)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M893.956,552.155c-1.635,1.57-9.154,3.2-9.154,3.2s1.844-7.486,3.463-9.056a4.089,4.089,0,1,1,5.691,5.859Z",
    transform: "translate(-875.375 -529.695)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M882.294,597.624c-2.016,1.014-9.694.315-9.694.315s4-6.591,6.014-7.6a4.088,4.088,0,0,1,3.68,7.294Z",
    transform: "translate(-859.436 -555.931)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M879.479,644.477c-1.815,1.341-9.5,1.946-9.5,1.946s2.845-7.175,4.644-8.516a4.088,4.088,0,0,1,4.857,6.57Z",
    transform: "translate(-854.985 -582.702)",
    fill: "#017572"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M345.563,151.734H342.75a1.971,1.971,0,1,0,0-3.937H319.965a1.971,1.971,0,0,0,0,3.937h2.813a1.971,1.971,0,1,0,0,3.937h-3.937a1.971,1.971,0,1,0,0,3.937h22.785a1.971,1.971,0,1,0,0-3.937h3.937a1.971,1.971,0,1,0,0-3.937Z",
    transform: "translate(2076.562 -1001.24)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29-2",
    "data-name": "Path 29",
    d: "M591.563,272.734H588.75a1.971,1.971,0,1,0,0-3.937H565.965a1.971,1.971,0,0,0,0,3.937h2.813a1.971,1.971,0,1,0,0,3.937h-3.937a1.971,1.971,0,1,0,0,3.937h22.785a1.971,1.971,0,1,0,0-3.937h3.937a1.971,1.971,0,1,0,0-3.937Z",
    transform: "translate(1931.752 -1071.836)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-2",
    "data-name": "Path 30",
    d: "M1010.563,114.734h-2.813a1.971,1.971,0,1,0,0-3.937H984.965a1.971,1.971,0,0,0,0,3.937h2.813a1.971,1.971,0,1,0,0,3.937h-3.937a1.971,1.971,0,1,0,0,3.937h22.785a1.971,1.971,0,0,0,0-3.937h3.937a1.971,1.971,0,1,0,0-3.937Z",
    transform: "translate(1685.156 -979.368)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-2",
    "data-name": "Path 31",
    d: "M519.367,465.94c-.315.229-.487.356-.487.356A2.07,2.07,0,0,0,519.367,465.94Z",
    transform: "translate(1957.504 -1187.306)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-2",
    "data-name": "Path 32",
    d: "M520.3,466.88c-.315.229-.487.356-.487.356A2.081,2.081,0,0,0,520.3,466.88Z",
    transform: "translate(1956.957 -1187.856)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-2",
    "data-name": "Path 33",
    d: "M520.3,465.94c-.315.229-.487.356-.487.356A2.077,2.077,0,0,0,520.3,465.94Z",
    transform: "translate(1956.957 -1187.306)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(2655.053 -724.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46-2",
    "data-name": "Path 46",
    d: "M1006.639,484.574s5.626-19.1-1.056-33.161a30.163,30.163,0,0,1-2.44-18.928,50.766,50.766,0,0,1,2.68-8.894",
    transform: "translate(-992.631 -408.773)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47-2",
    "data-name": "Path 47",
    d: "M996.9,370c0,2.342,4.24,9.122,4.24,9.122s4.24-6.789,4.24-9.122a4.24,4.24,0,1,0-8.477,0Z",
    transform: "translate(-987.871 -365.66)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48-2",
    "data-name": "Path 48",
    d: "M1028.19,419.082c1.272,1.966,8.52,5.359,8.52,5.359s-.132-8-1.405-9.968a4.239,4.239,0,1,0-7.115,4.607Z",
    transform: "translate(-1026.161 -401.561)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49-2",
    "data-name": "Path 49",
    d: "M1021.694,511.547c2.091,1.054,10.06.326,10.06.326s-4.153-6.842-6.244-7.9a4.239,4.239,0,1,0-3.818,7.57Z",
    transform: "translate(-1019.36 -471.466)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-2",
    "data-name": "Path 50",
    d: "M1004.379,586.112c1.881,1.391,9.861,2.02,9.861,2.02s-2.937-7.444-4.819-8.837a4.239,4.239,0,1,0-5.042,6.817Z",
    transform: "translate(-998.038 -528.939)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-2",
    "data-name": "Path 51",
    d: "M992.286,442.354c-1.678,1.631-9.5,3.32-9.5,3.32s1.916-7.77,3.594-9.4a4.24,4.24,0,1,1,5.909,6.082Z",
    transform: "translate(-972.837 -418.932)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52-2",
    "data-name": "Path 52",
    d: "M969.251,526c-2.091,1.054-10.059.326-10.059.326s4.153-6.842,6.244-7.9A4.239,4.239,0,0,1,969.251,526Z",
    transform: "translate(-945.373 -482.591)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53-2",
    "data-name": "Path 53",
    d: "M963.835,613.272c-1.881,1.391-9.861,2.02-9.861,2.02s2.937-7.444,4.819-8.837a4.239,4.239,0,0,1,5.042,6.817Z",
    transform: "translate(-938.249 -549.774)",
    fill: "#017572"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortBuilding);
export default __webpack_public_path__ + "static/media/short-building.546705cfa13898bcfed080d7a5da77b9.svg";
export { ForwardRef as ReactComponent };